// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footer_item":"Footer_footer_item__pafTd"};